import React from 'react'

const CmtyCard = ({imgSrc, content}) => {
  return (
    <div className='w-[330px] h-[325px] rounded-3xl shadow-md bg-white flex flex-col  gap-5 pb-[30px]'>
      <div className='w-full h-[220px] rounded-lg  '> 
        <img src={imgSrc}
        className='object-cover rounded-t-3xl ' /></div>
      <div className='text-xl font-semibold px-5'>{content}</div>
    </div>
  )
}

export default CmtyCard